import { Profile, ProfileCustomValue } from "PFCore/types";
import { useMemo } from "react";

const sortSkills = (collection: ProfileCustomValue[]) =>
  collection.sort((skill1, skill2) => {
    const skillA = skill1.text?.toUpperCase() || String(skill1.value)?.toUpperCase();
    const skillB = skill2.text?.toUpperCase() || String(skill2.value)?.toUpperCase();
    if (skillA < skillB) {
      return -1;
    }
    if (skillA > skillB) {
      return 1;
    }
    return 0;
  });

export const useCategorizedSkills = (
  skills: ProfileCustomValue[],
  skillsCategories: Profile["skillCategories"]
) => {
  const [skillCategories, otherSkills] = useMemo<
    [Record<string, ProfileCustomValue[]>, ProfileCustomValue[]]
  >(() => {
    let otherSkills: ProfileCustomValue[] = [];

    const acc = (skills || []).reduce((acc, skill) => {
      const skillCategory = (skillsCategories || []).find(
        (item) => item[0].toLowerCase() === String(skill.value).toLowerCase()
      );
      if (skillCategory) {
        // the last one is experience, before the last one was the category name. Now is on the 3rd position
        const name = skillCategory[2];
        acc[name] = [skill, ...(acc[name] || [])];
      } else {
        otherSkills = [skill, ...otherSkills];
      }
      return acc;
    }, {});

    //acc sorting in alphabetical order
    const sortedSkillsCategories = Object.keys(acc).sort();
    const sortedSkills = sortedSkillsCategories.reduce(
      (sum, category) => ({
        ...sum,
        [category]: sortSkills(acc[category])
      }),
      {}
    );

    return [sortedSkills, sortSkills(otherSkills)];
  }, [skillsCategories, skills]);

  return [skillCategories, otherSkills];
};
